import "./style.css";
import Modal from "@/components/Modal";

export default class SubscriptionFailModal extends Modal {
  static selector = ".subscription-fail-modal";

  constructor(block) {
    super(block);

    this.block = block;
    this.goBackButton = this.block.querySelector(
      ".subscription-fail-modal__button"
    );
  }

  handleBackClick = () => {
    window.history.replaceState({}, document.title, "/profile");
    window.location.reload();
  };

  // Lifecycle methods
  onReady() {
    this.open();
    if (this.goBackButton) {
      this.goBackButton.addEventListener("click", this.handleBackClick);
    }
  }

  modalDidMount = async () => {};
  modalWillOpen = async () => {};

  modalDidUpdate = async () => {};
  modalDidClose = async () => {
    window.history.replaceState({}, document.title, "/profile");
    window.location.reload();
  };

  onDestroy() {
    if (this.goBackButton) {
      this.goBackButton.removeEventListener("click", this.handleBackClick);
    }
  }
}
